"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M23.5 5h-3.69l-.586-1.171A1.493 1.493 0 0 0 17.882 3h-2.301l-1.691-.563A8.465 8.465 0 0 0 11.202 2H1.5C.673 2 0 2.673 0 3.5v4C0 8.327.673 9 1.5 9h2.416l-.88 5.722L1.2 16.1c-.007.005-.008.014-.014.02a.487.487 0 0 0-.153.217c-.006.016-.006.031-.01.048-.009.038-.023.074-.023.115v4c0 .827.673 1.5 1.5 1.5h8c.827 0 1.5-.673 1.5-1.5v-4c0-.012-.006-.022-.007-.034a.488.488 0 0 0-.022-.107c-.007-.025-.012-.049-.023-.072a.49.49 0 0 0-.061-.09c-.015-.019-.026-.04-.043-.056a.508.508 0 0 0-.118-.08c-.013-.007-.023-.017-.036-.022l-3.138-1.345.339-2.206a.497.497 0 0 0 .593-.367l.5-2a.5.5 0 0 0-.364-.606.48.48 0 0 0-.274.017L9.428 9h1.774c.915 0 1.819-.147 2.688-.437L15.581 8h2.301c.572 0 1.086-.318 1.342-.83L19.809 6H23.5a.5.5 0 0 0 0-1ZM11 20.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5V17h9v3.5Zm-3.197-5.041L9.064 16H3l.8-.601a.498.498 0 0 0 .194-.324L4.929 9h3.488l-.911 5.923a.5.5 0 0 0 .297.536Zm5.771-7.844A7.468 7.468 0 0 1 11.202 8H1.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5l9.702-.001c.808 0 1.606.13 2.372.385L15 3.86v3.28l-1.426.475Zm4.755-.891a.497.497 0 0 1-.447.276h-1.881V4h1.881c.191 0 .362.106.447.276l.612 1.224-.612 1.224Z"
  })]
});